import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { PartnershipListSuccessResponse } from "./api-response/PartnershipListSuccessResponse";
import { map } from "rxjs/operators";

export class ApiPartnership {
  constructor(private apiEndpoint: string) {}

  listForOrganization(
    token: string,
    organization: OrganizationKeyName
  ): Observable<PartnershipListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/partnerships`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
